<template>
  <div
    class="moodboard-notification"
    :class="{show: hasMoodboard, rollout: isMoodboardNotificationRollout}"
    @mouseleave="toggleRollout(false)"
    @mouseenter="toggleRollout(true)"
  >
    <div class="icon" @click="toggleRollout()">
      <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">
        <path d="M29.75 3.14999C30.9053 3.14999 31.85 4.09471 31.85 5.24999V29.75C31.85 30.9053 30.9053 31.85 29.75 31.85H5.25C4.09472 31.85 3.15 30.9053 3.15 29.75V5.24999C3.15 4.09471 4.09472 3.14999 5.25 3.14999H29.75ZM29.75 1.74999H5.25C3.325 1.74999 1.75 3.32499 1.75 5.24999V29.75C1.75 31.675 3.325 33.25 5.25 33.25H29.75C31.675 33.25 33.25 31.675 33.25 29.75V5.24999C33.25 3.32499 31.675 1.74999 29.75 1.74999Z" fill="#FFFEF9"/>
        <path d="M17.1499 2.1V32.55" stroke="#FFFEF9" stroke-width="1.4" stroke-miterlimit="10" stroke-linejoin="round"/>
        <path d="M32.9 17.5H17.5" stroke="#FFFEF9" stroke-width="1.4" stroke-miterlimit="10" stroke-linejoin="round"/>
      </svg>
    </div>
    <div class="text">
      <a href="/inspiration/mood-board" @click.prevent="animateNavTo">
        View your moodboard
      </a>
    </div>
  </div>
</template>

<script>
import bus from '../../utilities/eventbus';

export default {
  name: "v-moodboard-notification",
  data () {
      return {
        isMoodboardNotificationRollout: false,
        hasMoodboard: false,
        notification: null,
      }
  },
  methods: {
    toggleRollout(state = !this.isMoodboardNotificationRollout) {
      this.isMoodboardNotificationRollout = state
    },
    moodboardAdded() {
      const moodBoardsCookie = this.$cookies.get('MoodBoard')

      if (moodBoardsCookie) {
        this.hasMoodboard = true

        // check if it is moodboard modal
        const { body } = document
        const isMoodboardModal = body.classList.contains('fs-modal-visible');

        if (!this.isBlacklistedPage() || isMoodboardModal) {
          this.toggleRollout(true)
        }

        if (this.notification) {
          clearTimeout(this.notification)
        }

        this.notification = setTimeout(() => {
          this.toggleRollout(false)
        }, 3000)
      } else {
        this.hasMoodboard = false
      }
    },
    isBlacklistedPage() {
      const currentUrlString = window?.location?.href || ''
      const blacklistPages = ['/inspiration/mood-board/']
      let currentUrl = null
      let pathname = ''

      if (currentUrlString) {
        currentUrl = new URL(currentUrlString)
        pathname = currentUrl.pathname
      }

      return blacklistPages.includes(pathname)
    },
    shouldNotificationDisplay() {
      const moodBoardsCookie = this.$cookies.get('MoodBoard')
      this.hasMoodboard = !!moodBoardsCookie
    },
    animateNavTo(ev) {
      const target = ev.target.tagName === 'A' ? ev.target : ev.target.closest('a');
      this.linkOverlayShow(target.href);
    },
  },
  mounted() {
    this.shouldNotificationDisplay()
  },
  created() {
    bus.$on('moodboardAdded', this.moodboardAdded);
  }
};
</script>

<style lang="scss" scoped>
@import "../../../scss/abstracts/variables";

.moodboard-notification {
  background-color: $brand-black;
  color: #FFFEF9;
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 180px;
  right: 0;
  transform: translateX(207px);
  padding: 8px;
  transition: transform 0.3s ease-in-out;
  z-index: 1000;

  @media #{$md} {
    bottom: 100px;
  }

  &.rollout {
    transform: translateX(0) !important;
  }

  &.show {
    transform: translateX(157px);
  }

  .icon {
    display: flex;
    cursor: pointer;
  }

  .text {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    padding: 0 6px;
  }
}

</style>
